var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewMobileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 200,
    viewBox: "0 0 311 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.485 107.363C236.05 98.7914 259.2 84.1657 276.894 68.2862L276.907 68.313C277.597 67.6686 278.022 66.7929 278.102 65.8547C278.182 64.9164 277.911 63.9819 277.341 63.231C276.77 62.4801 275.941 61.966 275.013 61.7876C274.085 61.6091 273.124 61.7791 272.314 62.2647C254.565 72.8763 234.977 81.2771 214.897 86.4047C215.497 78.7684 215.37 71.0836 214.383 63.4422C212.113 46.4749 206.351 29.521 194.37 16.6082C181.1 1.92904 159.314 -3.5573 140.509 2.31703C117.917 9.03437 99.0863 29.3871 98.361 53.6739C97.4476 85.6549 127.239 111.721 157.554 114.652C161.09 115.039 164.658 115.227 168.245 115.232C162.655 127.448 155.401 139.118 147.64 149.924C123.805 110.608 88.0739 78.4059 45.6016 60.7928C35.7099 56.608 25.4547 53.3337 14.964 51.0111C11.3912 50.2751 7.99302 49.6195 4.21873 49.2047C3.30229 49.1181 2.38501 49.3611 1.63279 49.8897C0.880577 50.4184 0.343068 51.1977 0.117513 52.0869C-0.108043 52.976 -0.00677404 53.9162 0.403008 54.7374C0.812791 55.5587 1.50404 56.2067 2.35172 56.5643C26.0643 68.2894 47.8123 83.6003 66.8235 101.953C91.4599 125.655 110.869 154.21 123.814 185.799C129.522 199.408 147.427 204.386 159.408 195.635C161.247 194.279 162.927 192.721 164.418 190.991C175.159 179.348 184.615 166.589 192.624 152.935C200.806 138.982 207.546 123.483 211.485 107.363ZM158.329 169.694L158.333 169.702L158.642 170.331C158.543 170.116 158.439 169.903 158.329 169.694ZM176.617 91.2428C178.492 83.2299 179.424 75.0831 179.125 66.8811C178.333 52.1618 172.665 31.3676 155.163 31.0464C140.093 30.8725 126.232 45.11 130.543 60.2307C136.925 82.2986 155.983 90.3475 176.617 91.2428Z",
    fill: "url(#paint0_linear_5996_3879)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M288.539 53.2725C290.084 60.4716 292.461 65.0345 299.405 64.1112C305.369 63.3217 310.285 57.3403 310.285 51.3589C310.285 45.3776 305.342 41.5103 299.405 42.447C291.87 43.638 287.277 47.4249 288.539 53.2725Z",
    fill: "url(#paint1_linear_5996_3879)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5996_3879",
    x1: 0,
    y1: 0,
    x2: 310,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44BCC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#236D66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5996_3879",
    x1: 0,
    y1: 0,
    x2: 310,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44BCC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#236D66"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMobileLogo);
export default __webpack_public_path__ + "static/media/new-mobile-logo.1301703cff6fc72572cbdb63148039d9.svg";
export { ForwardRef as ReactComponent };